import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=3e84fbe5&scoped=true&"
var script = {}
import style0 from "./BackButton.vue?vue&type=style&index=0&id=3e84fbe5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e84fbe5",
  null
  
)

export default component.exports